var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-alert',[_vm._v(" "+_vm._s(_vm.$t(("modules." + (_vm.$route.params.module) + ".entities." + _vm.entityType + ".fields." + _vm.id)))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }